import { getApiUrl, getEnvironmentConfig, isSaaSSubdomain } from './utils/environment';

// Dynamic API URL based on subdomain
export const getDynamicApiUrl = () => getApiUrl();

// Always use dynamic API URL based on current subdomain
export const API = getDynamicApiUrl();

// Check if we're on a SaaS subdomain
export const isSaaS = () => isSaaSSubdomain();

// Environment configuration
export const getEnvConfig = () => getEnvironmentConfig();
